import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEAutomobileCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Automobile Engineering",
    shortName: "B.E. Automobile",
    duration: "4 years",
    description: "Specialized engineering program focused on design, manufacturing, and maintenance of automotive vehicles and systems",
    overview: "Bachelor of Engineering in Automobile Engineering (B.E. Automobile) is a 4-year undergraduate program that combines mechanical engineering principles with automotive technology. This course covers vehicle design, engine systems, transmission, safety features, and emerging technologies like electric and autonomous vehicles, preparing students for careers in the rapidly evolving automotive industry.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Interest in automotive technology and vehicles"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Workshop Technology",
          "Basic Mechanical Engineering"
        ]
      },
      {
        year: 2,
        subjects: [
          "Strength of Materials",
          "Thermodynamics",
          "Fluid Mechanics",
          "Manufacturing Processes",
          "Materials Science",
          "Engineering Mechanics"
        ]
      },
      {
        year: 3,
        subjects: [
          "Internal Combustion Engines",
          "Automotive Chassis",
          "Vehicle Dynamics",
          "Transmission Systems",
          "Automotive Electronics",
          "Heat Transfer"
        ]
      },
      {
        year: 4,
        subjects: [
          "Alternative Fuels and Hybrid Vehicles",
          "Automotive Design",
          "Vehicle Safety and Testing",
          "Electric Vehicle Technology",
          "Project Work",
          "Industrial Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Automotive Engineer",
        "Design Engineer",
        "Production Engineer",
        "Quality Control Engineer",
        "R&D Engineer",
        "Service Engineer",
        "Sales Engineer",
        "Test Engineer"
      ],
      industries: [
        "Automobile Manufacturers",
        "Auto Component Companies",
        "Research and Development",
        "Automotive Consulting",
        "Government Transport Departments",
        "Racing and Motorsports",
        "Electric Vehicle Companies",
        "Automotive Testing Labs"
      ],
      averageSalary: "₹4-8 LPA (Fresher), ₹12-25 LPA (Experienced)",
      topRecruiters: [
        "Tata Motors, Mahindra",
        "Maruti Suzuki, Hyundai",
        "Bajaj Auto, TVS Motors",
        "Bosch, Continental",
        "Ashok Leyland, Eicher",
        "Ola Electric, Ather Energy"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "College of Engineering Guindy, Anna University",
        location: "Chennai",
        fees: "₹2,00,000",
        ranking: "NIRF Ranking: 35"
      },
      {
        name: "PSG College of Technology",
        location: "Coimbatore",
        fees: "₹4,50,000",
        ranking: "NIRF Ranking: 42"
      },
      {
        name: "Sri Venkateswara College of Engineering",
        location: "Chennai",
        fees: "₹3,50,000",
        ranking: "NAAC A Grade"
      },
      {
        name: "Rajalakshmi Engineering College",
        location: "Chennai",
        fees: "₹3,80,000",
        ranking: "NAAC A Grade"
      }
    ],

    skills: [
      "Vehicle Design and Development",
      "Engine Technology",
      "CAD/CAM Software",
      "Automotive Testing",
      "Quality Control",
      "Electric Vehicle Technology",
      "Manufacturing Processes",
      "Problem Solving",
      "Project Management",
      "Technical Communication"
    ],

    futureScope: "Excellent opportunities with the shift towards electric vehicles, autonomous driving, and sustainable transportation, along with traditional automotive manufacturing and service sectors.",

    faqs: [
      {
        question: "What is the scope of Automobile Engineering?",
        answer: "Very broad scope including vehicle design, manufacturing, testing, service, and emerging areas like electric vehicles, autonomous driving, and connected car technologies."
      },
      {
        question: "Are there opportunities in electric vehicle companies?",
        answer: "Yes, excellent opportunities in the rapidly growing EV sector with companies like Ola Electric, Ather Energy, Tata Motors EV division, and many startups."
      },
      {
        question: "Can I work in motorcycle companies?",
        answer: "Absolutely! Companies like Bajaj Auto, TVS Motors, Hero MotoCorp, and Royal Enfield offer excellent opportunities for automobile engineers."
      },
      {
        question: "What are the higher study options?",
        answer: "M.E./M.Tech in Automobile Engineering, MBA, or specialized courses in electric vehicle technology and automotive design."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEAutomobileCoursePage;
